(function () {
  const initSlider = () => {
    $(".featured-collection-slider__section").each(function () {
      if ($(this).hasClass("slider_started")) return;

      $(this).addClass("slider_started");

      const swiperEl = $(this).find(".featured-collection-slider__swiper")[0];
      if (!swiperEl) return;

      const slidesPerView = parseInt($(this).data("slides-per-view")) || 4;
      const slidesPerViewMobile = parseFloat($(this).data("slides-per-view-mobile")) || 2.5;
      const autoplay = $(this).data("autoplay") === true;
      const delay = parseInt($(this).data("delay")) * 1000 || 5000;
      const loop = $(this).data("loop") === true;

      new Swiper(swiperEl, {
        slidesPerView: slidesPerViewMobile,
        spaceBetween: 16,
        freeMode: true,
        loop: loop,
        navigation: {
          nextEl: swiperEl.querySelector(".swiper-button-next"),
          prevEl: swiperEl.querySelector(".swiper-button-prev"),
        },
        pagination: {
          el: swiperEl.querySelector(".swiper-pagination"),
          clickable: true,
        },
        autoplay: autoplay ? { delay: delay, disableOnInteraction: false } : false,
        breakpoints: {
          576: { slidesPerView: Math.min(slidesPerView, 2), spaceBetween: 20, freeMode: false },
          768: { slidesPerView: Math.min(slidesPerView, 3), spaceBetween: 24, freeMode: false },
          1024: { slidesPerView: slidesPerView, spaceBetween: 30, freeMode: false },
        },
      });
    });
  };

  document.addEventListener("DOMContentLoaded", initSlider);

  if (typeof Shopify !== "undefined" && Shopify.designMode) {
    document.addEventListener("shopify:section:load", initSlider);
  }
})();
